var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarUploadLineDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2183_175)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.042 6.375C13.5826 6.3835 14.417 6.45221 14.961 6.99621C15.5837 7.61883 15.5837 8.62042 15.5837 10.6236V11.3319C15.5837 13.3358 15.5837 14.3374 14.961 14.96C14.3391 15.5819 13.3368 15.5819 11.3337 15.5819H5.66699C3.66383 15.5819 2.66153 15.5819 2.03962 14.96C1.41699 14.3367 1.41699 13.3358 1.41699 11.3319V10.6236C1.41699 8.62042 1.41699 7.61883 2.03962 6.99621C2.58362 6.45221 3.41803 6.3835 4.95866 6.375",
    stroke: "#27346A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.6243V1.41602M8.5 1.41602L10.625 3.89518M8.5 1.41602L6.375 3.89518",
    stroke: "#27346A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2183_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarUploadLineDuotone);
export default __webpack_public_path__ + "static/media/solar_upload-line-duotone.ce047d60d6d1a1997faf997815795d67.svg";
export { ForwardRef as ReactComponent };